import React, { useRef, useState } from "react";
import { Modal, Image, Button } from "react-bootstrap";
import { fetch } from "../../utils";

const ProdcutImagesUpdate = ({ show, onClose, selectedProduct, products, getProductList }) => {
  const thumbnailRef = useRef(null);
  const uploadImagesRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const product = products.find((item) => item.product_id === selectedProduct);

  const error = (e) => {
    alert(e?.response?.data?.message || e?.message || "Something went wrong");
  };

  const changeThumbnail = () => thumbnailRef.current?.click();

  const updateThumbnail = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !product) return;

    const formData = new FormData();
    formData.append("product_id", product.product_id);
    formData.append("image", file);

    try {
      setLoading(true);
      const response = await fetch("product/update-thumbnail", "POST", formData, null);

      if (response.status === 200 && response.data.success) {
        alert(response.data.message || "Thumbnail updated successfully");
        await getProductList?.();
      } else {
        alert(response.data?.message || "Unable to update thumbnail");
      }
    } catch (e) {
      error(e);
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const uploadImages = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length || !product) return;

    const formData = new FormData();
    formData.append("product_id", product.product_id);
    files.forEach((file) => formData.append("images", file));

    try {
      setLoading(true);
      const response = await fetch("product/edit-product-images", "POST", formData, null);

      if (response.status === 200 && response.data.success) {
        alert(response.data.message || "Images uploaded successfully");
        await getProductList?.();
      } else {
        alert(response.data?.message || "Unable to upload images");
      }
    } catch (e) {
      error(e);
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const deleteImage = async (imageId) => {
    if (!product || !imageId) return;
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    try {
      setLoading(true);

      const response = await fetch(
        "product/delete-product-image",
        "POST",
        {
          product_id: product.product_id,
          product_img_id: imageId
        },
        null
      );

      if (response.status === 200 && response.data.success) {
        alert(response.data.message || "Product image deleted successfully");
        await getProductList?.();
      } else {
        alert(response.data?.message || "Unable to delete product image");
      }
    } catch (e) {
      error(e);
    } finally {
      setLoading(false);
    }
  };

  if (!product) return null;

  return (
    <Modal size="lg" show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Product Images</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div className="col-sm-5">
            <h6>Thumbnail</h6>

            <Image
              src={product.product_thumbnail?.url}
              thumbnail
              className="w-100"
            />

            <Button
              variant="primary"
              className="w-100 mt-2"
              onClick={changeThumbnail}
              disabled={loading}
            >
              Change Thumbnail
            </Button>

            <input
              ref={thumbnailRef}
              type="file"
              accept="image/*"
              hidden
              onChange={updateThumbnail}
            />
          </div>

          <div className="col-sm-7">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Product Images</h6>

              <Button
                variant="success"
                size="sm"
                onClick={() => uploadImagesRef.current?.click()}
                disabled={loading}
              >
                + Upload Images
              </Button>

              <input
                ref={uploadImagesRef}
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={uploadImages}
              />
            </div>

            <div className="row">
              {product.images?.length ? (
                product.images.map((img) => (
                  <div className="col-sm-4 mb-3" key={img.product_img_id}>
                    <div className="border rounded p-2">
                      <Image
                        src={img.img}
                        thumbnail
                        className="w-100"
                        style={{ height: 200, objectFit: "contain" }}
                      />

                      <Button
                        variant="danger"
                        size="sm"
                        className="w-100 mt-2"
                        onClick={() => deleteImage(img.product_img_id)}
                        disabled={loading}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center text-muted py-4">
                  No product images found.
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProdcutImagesUpdate;